var map = {
	"../pages/404/no-page.module": [
		"./src/app/pages/404/no-page.module.ts",
		"pages-404-no-page-module"
	],
	"../pages/admin/academics/chapters/completed/view.module": [
		"./src/app/pages/admin/academics/chapters/completed/view.module.ts",
		"pages-admin-academics-chapters-completed-view-module"
	],
	"../pages/admin/academics/chapters/in-progress/view.module": [
		"./src/app/pages/admin/academics/chapters/in-progress/view.module.ts",
		"pages-admin-academics-chapters-in-progress-view-module"
	],
	"../pages/admin/academics/chapters/list/list.module": [
		"./src/app/pages/admin/academics/chapters/list/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-academics-chapters-list-list-module"
	],
	"../pages/admin/academics/chapters/questions/questions.module": [
		"./src/app/pages/admin/academics/chapters/questions/questions.module.ts",
		"pages-admin-academics-chapters-questions-questions-module"
	],
	"../pages/admin/academics/chapters/result/result.module": [
		"./src/app/pages/admin/academics/chapters/result/result.module.ts",
		"default~pages-admin-academics-chapters-result-result-module~pages-staff-academics-chapters-result-re~35cdbf0b",
		"common",
		"pages-admin-academics-chapters-result-result-module"
	],
	"../pages/admin/academics/chapters/students-all/students-all.module": [
		"./src/app/pages/admin/academics/chapters/students-all/students-all.module.ts",
		"pages-admin-academics-chapters-students-all-students-all-module"
	],
	"../pages/admin/academics/chapters/upload/upload.module": [
		"./src/app/pages/admin/academics/chapters/upload/upload.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-academics-chapters-upload-upload-module"
	],
	"../pages/admin/academics/chapters/view/view.module": [
		"./src/app/pages/admin/academics/chapters/view/view.module.ts",
		"pages-admin-academics-chapters-view-view-module"
	],
	"../pages/admin/academics/chapters/yet-to-start/view.module": [
		"./src/app/pages/admin/academics/chapters/yet-to-start/view.module.ts",
		"pages-admin-academics-chapters-yet-to-start-view-module"
	],
	"../pages/admin/academics/classes/classes.module": [
		"./src/app/pages/admin/academics/classes/classes.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-academics-classes-classes-module"
	],
	"../pages/admin/academics/exam/exam.module": [
		"./src/app/pages/admin/academics/exam/exam.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"common",
		"pages-admin-academics-exam-exam-module"
	],
	"../pages/admin/academics/no-data/no-data.module": [
		"./src/app/pages/admin/academics/no-data/no-data.module.ts",
		"pages-admin-academics-no-data-no-data-module"
	],
	"../pages/admin/academics/section/section.module": [
		"./src/app/pages/admin/academics/section/section.module.ts",
		"pages-admin-academics-section-section-module"
	],
	"../pages/admin/academics/subject/subject.module": [
		"./src/app/pages/admin/academics/subject/subject.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-academics-subject-subject-module"
	],
	"../pages/admin/academics/upload/upload.module": [
		"./src/app/pages/admin/academics/upload/upload.module.ts",
		"pages-admin-academics-upload-upload-module"
	],
	"../pages/admin/academics/year/year.module": [
		"./src/app/pages/admin/academics/year/year.module.ts",
		"pages-admin-academics-year-year-module"
	],
	"../pages/admin/activities/activities/activities.module": [
		"./src/app/pages/admin/activities/activities/activities.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"default~pages-admin-activities-activities-activities-module~pages-admin-attendance-student-view-view~85a64b12",
		"common",
		"pages-admin-activities-activities-activities-module"
	],
	"../pages/admin/activities/list/activities.module": [
		"./src/app/pages/admin/activities/list/activities.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"common",
		"pages-admin-activities-list-activities-module"
	],
	"../pages/admin/alert/approve/alert.module": [
		"./src/app/pages/admin/alert/approve/alert.module.ts",
		"default~pages-admin-alert-approve-alert-module~pages-admin-dashboard-dashboard-module",
		"common",
		"pages-admin-alert-approve-alert-module"
	],
	"../pages/admin/alert/list/alert.module": [
		"./src/app/pages/admin/alert/list/alert.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-alert-list-alert-module"
	],
	"../pages/admin/attendance/nt-staff/dashboard/attendance.module": [
		"./src/app/pages/admin/attendance/nt-staff/dashboard/attendance.module.ts",
		"default~pages-admin-attendance-nt-staff-dashboard-attendance-module~pages-admin-attendance-staff-das~397e715e",
		"common",
		"pages-admin-attendance-nt-staff-dashboard-attendance-module"
	],
	"../pages/admin/attendance/nt-staff/empty/empty.module": [
		"./src/app/pages/admin/attendance/nt-staff/empty/empty.module.ts",
		"pages-admin-attendance-nt-staff-empty-empty-module"
	],
	"../pages/admin/attendance/staff/dashboard/attendance.module": [
		"./src/app/pages/admin/attendance/staff/dashboard/attendance.module.ts",
		"default~pages-admin-attendance-nt-staff-dashboard-attendance-module~pages-admin-attendance-staff-das~397e715e",
		"common",
		"pages-admin-attendance-staff-dashboard-attendance-module"
	],
	"../pages/admin/attendance/staff/empty/empty.module": [
		"./src/app/pages/admin/attendance/staff/empty/empty.module.ts",
		"pages-admin-attendance-staff-empty-empty-module"
	],
	"../pages/admin/attendance/student/dashboard/attendance.module": [
		"./src/app/pages/admin/attendance/student/dashboard/attendance.module.ts",
		"pages-admin-attendance-student-dashboard-attendance-module"
	],
	"../pages/admin/attendance/student/view/view.module": [
		"./src/app/pages/admin/attendance/student/view/view.module.ts",
		"default~pages-admin-activities-activities-activities-module~pages-admin-attendance-student-view-view~85a64b12",
		"common",
		"pages-admin-attendance-student-view-view-module"
	],
	"../pages/admin/calendar/add-events/addevents.module": [
		"./src/app/pages/admin/calendar/add-events/addevents.module.ts",
		"pages-admin-calendar-add-events-addevents-module"
	],
	"../pages/admin/calendar/events/events.module": [
		"./src/app/pages/admin/calendar/events/events.module.ts",
		"pages-admin-calendar-events-events-module"
	],
	"../pages/admin/calendar/upload/upload.module": [
		"./src/app/pages/admin/calendar/upload/upload.module.ts",
		"pages-admin-calendar-upload-upload-module"
	],
	"../pages/admin/calendar/view-events/viewevents.module": [
		"./src/app/pages/admin/calendar/view-events/viewevents.module.ts",
		"pages-admin-calendar-view-events-viewevents-module"
	],
	"../pages/admin/contact/edit/edit.module": [
		"./src/app/pages/admin/contact/edit/edit.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-contact-edit-edit-module"
	],
	"../pages/admin/contact/view/view.module": [
		"./src/app/pages/admin/contact/view/view.module.ts",
		"pages-admin-contact-view-view-module"
	],
	"../pages/admin/dashboard/dashboard.module": [
		"./src/app/pages/admin/dashboard/dashboard.module.ts",
		"default~pages-admin-alert-approve-alert-module~pages-admin-dashboard-dashboard-module",
		"common",
		"pages-admin-dashboard-dashboard-module"
	],
	"../pages/admin/enquiry/add/add.module": [
		"./src/app/pages/admin/enquiry/add/add.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"default~pages-admin-activities-activities-activities-module~pages-admin-attendance-student-view-view~85a64b12",
		"common",
		"pages-admin-enquiry-add-add-module"
	],
	"../pages/admin/enquiry/admission-enquiry-list/list.module": [
		"./src/app/pages/admin/enquiry/admission-enquiry-list/list.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"common",
		"pages-admin-enquiry-admission-enquiry-list-list-module"
	],
	"../pages/admin/enquiry/admission-view/view.module": [
		"./src/app/pages/admin/enquiry/admission-view/view.module.ts",
		"common",
		"pages-admin-enquiry-admission-view-view-module"
	],
	"../pages/admin/enquiry/edit/edit.module": [
		"./src/app/pages/admin/enquiry/edit/edit.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-enquiry-edit-edit-module"
	],
	"../pages/admin/enquiry/list/list.module": [
		"./src/app/pages/admin/enquiry/list/list.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"common",
		"pages-admin-enquiry-list-list-module"
	],
	"../pages/admin/enquiry/upload/upload.module": [
		"./src/app/pages/admin/enquiry/upload/upload.module.ts",
		"pages-admin-enquiry-upload-upload-module"
	],
	"../pages/admin/enquiry/view/view.module": [
		"./src/app/pages/admin/enquiry/view/view.module.ts",
		"pages-admin-enquiry-view-view-module"
	],
	"../pages/admin/exam-results/edit/edit.module": [
		"./src/app/pages/admin/exam-results/edit/edit.module.ts",
		"pages-admin-exam-results-edit-edit-module"
	],
	"../pages/admin/exam-results/grade-settings/gradeSettings.module": [
		"./src/app/pages/admin/exam-results/grade-settings/gradeSettings.module.ts",
		"pages-admin-exam-results-grade-settings-gradeSettings-module"
	],
	"../pages/admin/exam-results/list-class/list.module": [
		"./src/app/pages/admin/exam-results/list-class/list.module.ts",
		"pages-admin-exam-results-list-class-list-module"
	],
	"../pages/admin/exam-results/manualupload/manualupload.module": [
		"./src/app/pages/admin/exam-results/manualupload/manualupload.module.ts",
		"pages-admin-exam-results-manualupload-manualupload-module"
	],
	"../pages/admin/exam-results/marklist/marklist.module": [
		"./src/app/pages/admin/exam-results/marklist/marklist.module.ts",
		"pages-admin-exam-results-marklist-marklist-module"
	],
	"../pages/admin/exam-results/results/results.module": [
		"./src/app/pages/admin/exam-results/results/results.module.ts",
		"pages-admin-exam-results-results-results-module"
	],
	"../pages/admin/exam-results/upload/upload.module": [
		"./src/app/pages/admin/exam-results/upload/upload.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-exam-results-upload-upload-module"
	],
	"../pages/admin/feedback/list/list.module": [
		"./src/app/pages/admin/feedback/list/list.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"common",
		"pages-admin-feedback-list-list-module"
	],
	"../pages/admin/feedback/view/view.module": [
		"./src/app/pages/admin/feedback/view/view.module.ts",
		"pages-admin-feedback-view-view-module"
	],
	"../pages/admin/fees-old/collection/dashboard/dashboard.module": [
		"./src/app/pages/admin/fees-old/collection/dashboard/dashboard.module.ts",
		"pages-admin-fees-old-collection-dashboard-dashboard-module"
	],
	"../pages/admin/fees-old/collection/list/list.module": [
		"./src/app/pages/admin/fees-old/collection/list/list.module.ts",
		"pages-admin-fees-old-collection-list-list-module"
	],
	"../pages/admin/fees-old/list/list.module": [
		"./src/app/pages/admin/fees-old/list/list.module.ts",
		"pages-admin-fees-old-list-list-module"
	],
	"../pages/admin/fees-old/upload/upload.module": [
		"./src/app/pages/admin/fees-old/upload/upload.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-fees-old-upload-upload-module"
	],
	"../pages/admin/fees-old/view/view.module": [
		"./src/app/pages/admin/fees-old/view/view.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-fees-old-view-view-module"
	],
	"../pages/admin/fees/add-discount/view.module": [
		"./src/app/pages/admin/fees/add-discount/view.module.ts",
		"pages-admin-fees-add-discount-view-module"
	],
	"../pages/admin/fees/add-student-fees/view.module": [
		"./src/app/pages/admin/fees/add-student-fees/view.module.ts",
		"pages-admin-fees-add-student-fees-view-module"
	],
	"../pages/admin/fees/cancel-history/list.module": [
		"./src/app/pages/admin/fees/cancel-history/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-fees-cancel-history-list-module"
	],
	"../pages/admin/fees/discount/discount.module": [
		"./src/app/pages/admin/fees/discount/discount.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-fees-discount-discount-module"
	],
	"../pages/admin/fees/edit-discount/view.module": [
		"./src/app/pages/admin/fees/edit-discount/view.module.ts",
		"pages-admin-fees-edit-discount-view-module"
	],
	"../pages/admin/fees/edit-student-fees/view.module": [
		"./src/app/pages/admin/fees/edit-student-fees/view.module.ts",
		"pages-admin-fees-edit-student-fees-view-module"
	],
	"../pages/admin/fees/list-i/list-i.module": [
		"./src/app/pages/admin/fees/list-i/list-i.module.ts",
		"pages-admin-fees-list-i-list-i-module"
	],
	"../pages/admin/fees/list/list.module": [
		"./src/app/pages/admin/fees/list/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-fees-list-list-module"
	],
	"../pages/admin/fees/payment-history/list.module": [
		"./src/app/pages/admin/fees/payment-history/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-fees-payment-history-list-module"
	],
	"../pages/admin/fees/payment/list-class/list.module": [
		"./src/app/pages/admin/fees/payment/list-class/list.module.ts",
		"pages-admin-fees-payment-list-class-list-module"
	],
	"../pages/admin/fees/payment/list/list.module": [
		"./src/app/pages/admin/fees/payment/list/list.module.ts",
		"pages-admin-fees-payment-list-list-module"
	],
	"../pages/admin/fees/payment/passbook/passbook.module": [
		"./src/app/pages/admin/fees/payment/passbook/passbook.module.ts",
		"common",
		"pages-admin-fees-payment-passbook-passbook-module"
	],
	"../pages/admin/fees/payment/pay/pay.module": [
		"./src/app/pages/admin/fees/payment/pay/pay.module.ts",
		"pages-admin-fees-payment-pay-pay-module"
	],
	"../pages/admin/fees/payment/payment-list/list.module": [
		"./src/app/pages/admin/fees/payment/payment-list/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"default~pages-admin-fees-payment-payment-list-list-module~pages-enquiry-management-list-list-module~~f8045f80",
		"default~pages-admin-fees-payment-payment-list-list-module~pages-enquiry-management-list-list-module",
		"common",
		"pages-admin-fees-payment-payment-list-list-module"
	],
	"../pages/admin/fees/payment/payment-success/success.module": [
		"./src/app/pages/admin/fees/payment/payment-success/success.module.ts",
		"pages-admin-fees-payment-payment-success-success-module"
	],
	"../pages/admin/fees/report-analysis/dashboard/view.module": [
		"./src/app/pages/admin/fees/report-analysis/dashboard/view.module.ts",
		"pages-admin-fees-report-analysis-dashboard-view-module"
	],
	"../pages/admin/fees/report-analysis/fees-collection/feescollection.module": [
		"./src/app/pages/admin/fees/report-analysis/fees-collection/feescollection.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-fees-report-analysis-fees-collection-feescollection-module"
	],
	"../pages/admin/fees/report-analysis/fees-deposit/list.module": [
		"./src/app/pages/admin/fees/report-analysis/fees-deposit/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-fees-report-analysis-fees-deposit-list-module"
	],
	"../pages/admin/fees/report-analysis/fees-not-paid/list.module": [
		"./src/app/pages/admin/fees/report-analysis/fees-not-paid/list.module.ts",
		"pages-admin-fees-report-analysis-fees-not-paid-list-module"
	],
	"../pages/admin/fees/report-analysis/fees-status/list.module": [
		"./src/app/pages/admin/fees/report-analysis/fees-status/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-fees-report-analysis-fees-status-list-module"
	],
	"../pages/admin/fees/report-analysis/term-report/termreport.module": [
		"./src/app/pages/admin/fees/report-analysis/term-report/termreport.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-fees-report-analysis-term-report-termreport-module"
	],
	"../pages/admin/forgot-password/forgot-password.module": [
		"./src/app/pages/admin/forgot-password/forgot-password.module.ts",
		"pages-admin-forgot-password-forgot-password-module"
	],
	"../pages/admin/group/add/add.module": [
		"./src/app/pages/admin/group/add/add.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-group-add-add-module"
	],
	"../pages/admin/group/edit/edit.module": [
		"./src/app/pages/admin/group/edit/edit.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-group-edit-edit-module"
	],
	"../pages/admin/group/list/group.module": [
		"./src/app/pages/admin/group/list/group.module.ts",
		"pages-admin-group-list-group-module"
	],
	"../pages/admin/landing/landing.module": [
		"./src/app/pages/admin/landing/landing.module.ts",
		"pages-admin-landing-landing-module"
	],
	"../pages/admin/leave/staff/staff.module": [
		"./src/app/pages/admin/leave/staff/staff.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"common",
		"pages-admin-leave-staff-staff-module"
	],
	"../pages/admin/leave/student/student.module": [
		"./src/app/pages/admin/leave/student/student.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"common",
		"pages-admin-leave-student-student-module"
	],
	"../pages/admin/login/login.module": [
		"./src/app/pages/admin/login/login.module.ts",
		"pages-admin-login-login-module"
	],
	"../pages/admin/non-teaching/add/add.module": [
		"./src/app/pages/admin/non-teaching/add/add.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-non-teaching-add-add-module"
	],
	"../pages/admin/non-teaching/edit/edit.module": [
		"./src/app/pages/admin/non-teaching/edit/edit.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-non-teaching-edit-edit-module"
	],
	"../pages/admin/non-teaching/list/list.module": [
		"./src/app/pages/admin/non-teaching/list/list.module.ts",
		"pages-admin-non-teaching-list-list-module"
	],
	"../pages/admin/non-teaching/upload/upload.module": [
		"./src/app/pages/admin/non-teaching/upload/upload.module.ts",
		"pages-admin-non-teaching-upload-upload-module"
	],
	"../pages/admin/non-teaching/view/view.module": [
		"./src/app/pages/admin/non-teaching/view/view.module.ts",
		"pages-admin-non-teaching-view-view-module"
	],
	"../pages/admin/photo-gallery/add/add.module": [
		"./src/app/pages/admin/photo-gallery/add/add.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-photo-gallery-add-add-module"
	],
	"../pages/admin/photo-gallery/category/category.module": [
		"./src/app/pages/admin/photo-gallery/category/category.module.ts",
		"pages-admin-photo-gallery-category-category-module"
	],
	"../pages/admin/photo-gallery/edit/edit.module": [
		"./src/app/pages/admin/photo-gallery/edit/edit.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-photo-gallery-edit-edit-module"
	],
	"../pages/admin/photo-gallery/gallery/gallery.module": [
		"./src/app/pages/admin/photo-gallery/gallery/gallery.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-photo-gallery-gallery-gallery-module"
	],
	"../pages/admin/photo-gallery/view/view.module": [
		"./src/app/pages/admin/photo-gallery/view/view.module.ts",
		"pages-admin-photo-gallery-view-view-module"
	],
	"../pages/admin/progress-report/progress-report.module": [
		"./src/app/pages/admin/progress-report/progress-report.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"default~pages-admin-activities-activities-activities-module~pages-admin-attendance-student-view-view~85a64b12",
		"common",
		"pages-admin-progress-report-progress-report-module"
	],
	"../pages/admin/reset-password/reset-password.module": [
		"./src/app/pages/admin/reset-password/reset-password.module.ts",
		"pages-admin-reset-password-reset-password-module"
	],
	"../pages/admin/school-management/academic-year/academic.module": [
		"./src/app/pages/admin/school-management/academic-year/academic.module.ts",
		"pages-admin-school-management-academic-year-academic-module"
	],
	"../pages/admin/school-management/enquiry-qr-generator/enquiryQrGenerator.module": [
		"./src/app/pages/admin/school-management/enquiry-qr-generator/enquiryQrGenerator.module.ts",
		"pages-admin-school-management-enquiry-qr-generator-enquiryQrGenerator-module"
	],
	"../pages/admin/school-management/inactive/list-class/list.module": [
		"./src/app/pages/admin/school-management/inactive/list-class/list.module.ts",
		"pages-admin-school-management-inactive-list-class-list-module"
	],
	"../pages/admin/school-management/inactive/list/list.module": [
		"./src/app/pages/admin/school-management/inactive/list/list.module.ts",
		"common",
		"pages-admin-school-management-inactive-list-list-module"
	],
	"../pages/admin/school-management/inactive/view/view.module": [
		"./src/app/pages/admin/school-management/inactive/view/view.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-school-management-inactive-view-view-module"
	],
	"../pages/admin/school-management/promotion/list-class/list.module": [
		"./src/app/pages/admin/school-management/promotion/list-class/list.module.ts",
		"pages-admin-school-management-promotion-list-class-list-module"
	],
	"../pages/admin/school-management/promotion/promote/promote.module": [
		"./src/app/pages/admin/school-management/promotion/promote/promote.module.ts",
		"pages-admin-school-management-promotion-promote-promote-module"
	],
	"../pages/admin/school-management/transfer/transfer.module": [
		"./src/app/pages/admin/school-management/transfer/transfer.module.ts",
		"pages-admin-school-management-transfer-transfer-module"
	],
	"../pages/admin/staff-allocation/allocate/allocate.module": [
		"./src/app/pages/admin/staff-allocation/allocate/allocate.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-staff-allocation-allocate-allocate-module"
	],
	"../pages/admin/staff-allocation/list/list.module": [
		"./src/app/pages/admin/staff-allocation/list/list.module.ts",
		"pages-admin-staff-allocation-list-list-module"
	],
	"../pages/admin/staff/add/add.module": [
		"./src/app/pages/admin/staff/add/add.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-staff-add-add-module"
	],
	"../pages/admin/staff/edit/edit.module": [
		"./src/app/pages/admin/staff/edit/edit.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-staff-edit-edit-module"
	],
	"../pages/admin/staff/list/list.module": [
		"./src/app/pages/admin/staff/list/list.module.ts",
		"pages-admin-staff-list-list-module"
	],
	"../pages/admin/staff/upload/upload.module": [
		"./src/app/pages/admin/staff/upload/upload.module.ts",
		"pages-admin-staff-upload-upload-module"
	],
	"../pages/admin/staff/view/view.module": [
		"./src/app/pages/admin/staff/view/view.module.ts",
		"pages-admin-staff-view-view-module"
	],
	"../pages/admin/student/add/add.module": [
		"./src/app/pages/admin/student/add/add.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-student-add-add-module"
	],
	"../pages/admin/student/classes/classes.module": [
		"./src/app/pages/admin/student/classes/classes.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-student-classes-classes-module"
	],
	"../pages/admin/student/edit/edit.module": [
		"./src/app/pages/admin/student/edit/edit.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-student-edit-edit-module"
	],
	"../pages/admin/student/list/list.module": [
		"./src/app/pages/admin/student/list/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-student-list-list-module"
	],
	"../pages/admin/student/report/report.module": [
		"./src/app/pages/admin/student/report/report.module.ts",
		"pages-admin-student-report-report-module"
	],
	"../pages/admin/student/tc/edit/tc.module": [
		"./src/app/pages/admin/student/tc/edit/tc.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-student-tc-edit-tc-module"
	],
	"../pages/admin/student/tc/view/tc.module": [
		"./src/app/pages/admin/student/tc/view/tc.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-student-tc-view-tc-module"
	],
	"../pages/admin/student/upload/upload.module": [
		"./src/app/pages/admin/student/upload/upload.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-student-upload-upload-module"
	],
	"../pages/admin/student/view/view.module": [
		"./src/app/pages/admin/student/view/view.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-student-view-view-module"
	],
	"../pages/admin/time-table/staff/add/add.module": [
		"./src/app/pages/admin/time-table/staff/add/add.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-admin-time-table-staff-add-add-module"
	],
	"../pages/admin/time-table/staff/list/list.module": [
		"./src/app/pages/admin/time-table/staff/list/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-time-table-staff-list-list-module"
	],
	"../pages/admin/time-table/staff/main/main.module": [
		"./src/app/pages/admin/time-table/staff/main/main.module.ts",
		"pages-admin-time-table-staff-main-main-module"
	],
	"../pages/admin/time-table/staff/upload/upload.module": [
		"./src/app/pages/admin/time-table/staff/upload/upload.module.ts",
		"pages-admin-time-table-staff-upload-upload-module"
	],
	"../pages/admin/time-table/student/add/add.module": [
		"./src/app/pages/admin/time-table/student/add/add.module.ts",
		"pages-admin-time-table-student-add-add-module"
	],
	"../pages/admin/time-table/student/classes/classes.module": [
		"./src/app/pages/admin/time-table/student/classes/classes.module.ts",
		"pages-admin-time-table-student-classes-classes-module"
	],
	"../pages/admin/time-table/student/list/list.module": [
		"./src/app/pages/admin/time-table/student/list/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-time-table-student-list-list-module"
	],
	"../pages/admin/time-table/student/upload/upload.module": [
		"./src/app/pages/admin/time-table/student/upload/upload.module.ts",
		"pages-admin-time-table-student-upload-upload-module"
	],
	"../pages/admin/time-table/unallocated-staff/list/list.module": [
		"./src/app/pages/admin/time-table/unallocated-staff/list/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-admin-time-table-unallocated-staff-list-list-module"
	],
	"../pages/admission-enquiry/admissionEnquiry.module": [
		"./src/app/pages/admission-enquiry/admissionEnquiry.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"default~pages-admin-activities-activities-activities-module~pages-admin-attendance-student-view-view~85a64b12",
		"common",
		"pages-admission-enquiry-admissionEnquiry-module"
	],
	"../pages/enquiry/dashboard/dashboard.module": [
		"./src/app/pages/enquiry/dashboard/dashboard.module.ts",
		"pages-enquiry-dashboard-dashboard-module"
	],
	"../pages/enquiry/login/login.module": [
		"./src/app/pages/enquiry/login/login.module.ts",
		"pages-enquiry-login-login-module"
	],
	"../pages/enquiry/management/add/add.module": [
		"./src/app/pages/enquiry/management/add/add.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"default~pages-admin-activities-activities-activities-module~pages-admin-attendance-student-view-view~85a64b12",
		"common",
		"pages-enquiry-management-add-add-module"
	],
	"../pages/enquiry/management/edit/edit.module": [
		"./src/app/pages/enquiry/management/edit/edit.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-classes-classes-module~843896ea",
		"common",
		"pages-enquiry-management-edit-edit-module"
	],
	"../pages/enquiry/management/list/list.module": [
		"./src/app/pages/enquiry/management/list/list.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"default~pages-admin-fees-payment-payment-list-list-module~pages-enquiry-management-list-list-module~~f8045f80",
		"default~pages-admin-fees-payment-payment-list-list-module~pages-enquiry-management-list-list-module",
		"common",
		"pages-enquiry-management-list-list-module"
	],
	"../pages/enquiry/management/upload/upload.module": [
		"./src/app/pages/enquiry/management/upload/upload.module.ts",
		"pages-enquiry-management-upload-upload-module"
	],
	"../pages/enquiry/management/view/view.module": [
		"./src/app/pages/enquiry/management/view/view.module.ts",
		"pages-enquiry-management-view-view-module"
	],
	"../pages/enquiry/success-view/view.module": [
		"./src/app/pages/enquiry/success-view/view.module.ts",
		"pages-enquiry-success-view-view-module"
	],
	"../pages/privacy-policy/privacy-policy.module": [
		"./src/app/pages/privacy-policy/privacy-policy.module.ts",
		"pages-privacy-policy-privacy-policy-module"
	],
	"../pages/session-expired/session-expired.module": [
		"./src/app/pages/session-expired/session-expired.module.ts",
		"pages-session-expired-session-expired-module"
	],
	"../pages/staff/academics/chapters/completed/view.module": [
		"./src/app/pages/staff/academics/chapters/completed/view.module.ts",
		"pages-staff-academics-chapters-completed-view-module"
	],
	"../pages/staff/academics/chapters/in-progress/view.module": [
		"./src/app/pages/staff/academics/chapters/in-progress/view.module.ts",
		"pages-staff-academics-chapters-in-progress-view-module"
	],
	"../pages/staff/academics/chapters/list/list.module": [
		"./src/app/pages/staff/academics/chapters/list/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-academics-chapters-list-list-module"
	],
	"../pages/staff/academics/chapters/questions/questions.module": [
		"./src/app/pages/staff/academics/chapters/questions/questions.module.ts",
		"pages-staff-academics-chapters-questions-questions-module"
	],
	"../pages/staff/academics/chapters/result/result.module": [
		"./src/app/pages/staff/academics/chapters/result/result.module.ts",
		"default~pages-admin-academics-chapters-result-result-module~pages-staff-academics-chapters-result-re~35cdbf0b",
		"common",
		"pages-staff-academics-chapters-result-result-module"
	],
	"../pages/staff/academics/chapters/upload/upload.module": [
		"./src/app/pages/staff/academics/chapters/upload/upload.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-academics-chapters-upload-upload-module"
	],
	"../pages/staff/academics/chapters/yet-to-start/view.module": [
		"./src/app/pages/staff/academics/chapters/yet-to-start/view.module.ts",
		"pages-staff-academics-chapters-yet-to-start-view-module"
	],
	"../pages/staff/academics/classes/classes.module": [
		"./src/app/pages/staff/academics/classes/classes.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-academics-classes-classes-module"
	],
	"../pages/staff/academics/exam/exam.module": [
		"./src/app/pages/staff/academics/exam/exam.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-academics-exam-exam-module"
	],
	"../pages/staff/academics/section/section.module": [
		"./src/app/pages/staff/academics/section/section.module.ts",
		"pages-staff-academics-section-section-module"
	],
	"../pages/staff/academics/subject/subject.module": [
		"./src/app/pages/staff/academics/subject/subject.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-academics-subject-subject-module"
	],
	"../pages/staff/academics/upload/upload.module": [
		"./src/app/pages/staff/academics/upload/upload.module.ts",
		"pages-staff-academics-upload-upload-module"
	],
	"../pages/staff/academics/year/year.module": [
		"./src/app/pages/staff/academics/year/year.module.ts",
		"pages-staff-academics-year-year-module"
	],
	"../pages/staff/activities/activities/activities.module": [
		"./src/app/pages/staff/activities/activities/activities.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"default~pages-admin-activities-activities-activities-module~pages-admin-attendance-student-view-view~85a64b12",
		"common",
		"pages-staff-activities-activities-activities-module"
	],
	"../pages/staff/activities/list/activities.module": [
		"./src/app/pages/staff/activities/list/activities.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"common",
		"pages-staff-activities-list-activities-module"
	],
	"../pages/staff/alert/list/alert.module": [
		"./src/app/pages/staff/alert/list/alert.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-alert-list-alert-module"
	],
	"../pages/staff/alert/received/notification.module": [
		"./src/app/pages/staff/alert/received/notification.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-alert-received-notification-module"
	],
	"../pages/staff/attendance/staff/dashboard/attendance.module": [
		"./src/app/pages/staff/attendance/staff/dashboard/attendance.module.ts",
		"default~pages-admin-attendance-nt-staff-dashboard-attendance-module~pages-admin-attendance-staff-das~397e715e",
		"common",
		"pages-staff-attendance-staff-dashboard-attendance-module"
	],
	"../pages/staff/attendance/staff/empty/empty.module": [
		"./src/app/pages/staff/attendance/staff/empty/empty.module.ts",
		"pages-staff-attendance-staff-empty-empty-module"
	],
	"../pages/staff/attendance/staff/upload/upload.module": [
		"./src/app/pages/staff/attendance/staff/upload/upload.module.ts",
		"pages-staff-attendance-staff-upload-upload-module"
	],
	"../pages/staff/attendance/student/dashboard/attendance.module": [
		"./src/app/pages/staff/attendance/student/dashboard/attendance.module.ts",
		"pages-staff-attendance-student-dashboard-attendance-module"
	],
	"../pages/staff/attendance/student/start-attendance/view.module": [
		"./src/app/pages/staff/attendance/student/start-attendance/view.module.ts",
		"pages-staff-attendance-student-start-attendance-view-module"
	],
	"../pages/staff/attendance/student/view/view.module": [
		"./src/app/pages/staff/attendance/student/view/view.module.ts",
		"pages-staff-attendance-student-view-view-module"
	],
	"../pages/staff/calendar/add-events/addevents.module": [
		"./src/app/pages/staff/calendar/add-events/addevents.module.ts",
		"pages-staff-calendar-add-events-addevents-module"
	],
	"../pages/staff/calendar/events/events.module": [
		"./src/app/pages/staff/calendar/events/events.module.ts",
		"pages-staff-calendar-events-events-module"
	],
	"../pages/staff/calendar/upload/upload.module": [
		"./src/app/pages/staff/calendar/upload/upload.module.ts",
		"pages-staff-calendar-upload-upload-module"
	],
	"../pages/staff/calendar/view-events/viewevents.module": [
		"./src/app/pages/staff/calendar/view-events/viewevents.module.ts",
		"pages-staff-calendar-view-events-viewevents-module"
	],
	"../pages/staff/dashboard/dashboard.module": [
		"./src/app/pages/staff/dashboard/dashboard.module.ts",
		"pages-staff-dashboard-dashboard-module"
	],
	"../pages/staff/email-login/login.module": [
		"./src/app/pages/staff/email-login/login.module.ts",
		"pages-staff-email-login-login-module"
	],
	"../pages/staff/enquiry/add/add.module": [
		"./src/app/pages/staff/enquiry/add/add.module.ts",
		"pages-staff-enquiry-add-add-module"
	],
	"../pages/staff/enquiry/edit/edit.module": [
		"./src/app/pages/staff/enquiry/edit/edit.module.ts",
		"pages-staff-enquiry-edit-edit-module"
	],
	"../pages/staff/enquiry/list/list.module": [
		"./src/app/pages/staff/enquiry/list/list.module.ts",
		"pages-staff-enquiry-list-list-module"
	],
	"../pages/staff/enquiry/view/view.module": [
		"./src/app/pages/staff/enquiry/view/view.module.ts",
		"pages-staff-enquiry-view-view-module"
	],
	"../pages/staff/exam-results/edit/edit.module": [
		"./src/app/pages/staff/exam-results/edit/edit.module.ts",
		"pages-staff-exam-results-edit-edit-module"
	],
	"../pages/staff/exam-results/list-classes/classes.module": [
		"./src/app/pages/staff/exam-results/list-classes/classes.module.ts",
		"pages-staff-exam-results-list-classes-classes-module"
	],
	"../pages/staff/exam-results/manualupload/manualupload.module": [
		"./src/app/pages/staff/exam-results/manualupload/manualupload.module.ts",
		"pages-staff-exam-results-manualupload-manualupload-module"
	],
	"../pages/staff/exam-results/marklist/marklist.module": [
		"./src/app/pages/staff/exam-results/marklist/marklist.module.ts",
		"pages-staff-exam-results-marklist-marklist-module"
	],
	"../pages/staff/exam-results/results/results.module": [
		"./src/app/pages/staff/exam-results/results/results.module.ts",
		"pages-staff-exam-results-results-results-module"
	],
	"../pages/staff/exam-results/upload/upload.module": [
		"./src/app/pages/staff/exam-results/upload/upload.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-exam-results-upload-upload-module"
	],
	"../pages/staff/feedback/list/list.module": [
		"./src/app/pages/staff/feedback/list/list.module.ts",
		"pages-staff-feedback-list-list-module"
	],
	"../pages/staff/feedback/view/view.module": [
		"./src/app/pages/staff/feedback/view/view.module.ts",
		"pages-staff-feedback-view-view-module"
	],
	"../pages/staff/fees/list/list.module": [
		"./src/app/pages/staff/fees/list/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-fees-list-list-module"
	],
	"../pages/staff/fees/view/view.module": [
		"./src/app/pages/staff/fees/view/view.module.ts",
		"pages-staff-fees-view-view-module"
	],
	"../pages/staff/leave/mine/staff.module": [
		"./src/app/pages/staff/leave/mine/staff.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"default~pages-admin-fees-payment-payment-list-list-module~pages-enquiry-management-list-list-module~~f8045f80",
		"common",
		"pages-staff-leave-mine-staff-module"
	],
	"../pages/staff/leave/student/student.module": [
		"./src/app/pages/staff/leave/student/student.module.ts",
		"default~pages-admin-academics-exam-exam-module~pages-admin-activities-activities-activities-module~p~bba3a340",
		"common",
		"pages-staff-leave-student-student-module"
	],
	"../pages/staff/login/login.module": [
		"./src/app/pages/staff/login/login.module.ts",
		"pages-staff-login-login-module"
	],
	"../pages/staff/non-teaching/add/add.module": [
		"./src/app/pages/staff/non-teaching/add/add.module.ts",
		"pages-staff-non-teaching-add-add-module"
	],
	"../pages/staff/non-teaching/edit/edit.module": [
		"./src/app/pages/staff/non-teaching/edit/edit.module.ts",
		"pages-staff-non-teaching-edit-edit-module"
	],
	"../pages/staff/non-teaching/list/list.module": [
		"./src/app/pages/staff/non-teaching/list/list.module.ts",
		"pages-staff-non-teaching-list-list-module"
	],
	"../pages/staff/non-teaching/upload/upload.module": [
		"./src/app/pages/staff/non-teaching/upload/upload.module.ts",
		"pages-staff-non-teaching-upload-upload-module"
	],
	"../pages/staff/non-teaching/view/view.module": [
		"./src/app/pages/staff/non-teaching/view/view.module.ts",
		"pages-staff-non-teaching-view-view-module"
	],
	"../pages/staff/notification/received/notification.module": [
		"./src/app/pages/staff/notification/received/notification.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-notification-received-notification-module"
	],
	"../pages/staff/notification/sent/notification.module": [
		"./src/app/pages/staff/notification/sent/notification.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-notification-sent-notification-module"
	],
	"../pages/staff/otp/otp.module": [
		"./src/app/pages/staff/otp/otp.module.ts",
		"pages-staff-otp-otp-module"
	],
	"../pages/staff/resend-otp/resend-otp.module": [
		"./src/app/pages/staff/resend-otp/resend-otp.module.ts",
		"pages-staff-resend-otp-resend-otp-module"
	],
	"../pages/staff/staff/add/add.module": [
		"./src/app/pages/staff/staff/add/add.module.ts",
		"pages-staff-staff-add-add-module"
	],
	"../pages/staff/staff/edit/edit.module": [
		"./src/app/pages/staff/staff/edit/edit.module.ts",
		"pages-staff-staff-edit-edit-module"
	],
	"../pages/staff/staff/list/list.module": [
		"./src/app/pages/staff/staff/list/list.module.ts",
		"pages-staff-staff-list-list-module"
	],
	"../pages/staff/staff/upload/upload.module": [
		"./src/app/pages/staff/staff/upload/upload.module.ts",
		"pages-staff-staff-upload-upload-module"
	],
	"../pages/staff/staff/view/view.module": [
		"./src/app/pages/staff/staff/view/view.module.ts",
		"pages-staff-staff-view-view-module"
	],
	"../pages/staff/student/add/add.module": [
		"./src/app/pages/staff/student/add/add.module.ts",
		"pages-staff-student-add-add-module"
	],
	"../pages/staff/student/classes/classes.module": [
		"./src/app/pages/staff/student/classes/classes.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-student-classes-classes-module"
	],
	"../pages/staff/student/edit/edit.module": [
		"./src/app/pages/staff/student/edit/edit.module.ts",
		"pages-staff-student-edit-edit-module"
	],
	"../pages/staff/student/list/list.module": [
		"./src/app/pages/staff/student/list/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-student-list-list-module"
	],
	"../pages/staff/student/upload/upload.module": [
		"./src/app/pages/staff/student/upload/upload.module.ts",
		"pages-staff-student-upload-upload-module"
	],
	"../pages/staff/student/view/view.module": [
		"./src/app/pages/staff/student/view/view.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-staff-student-view-view-module"
	],
	"../pages/staff/time-table/add/add.module": [
		"./src/app/pages/staff/time-table/add/add.module.ts",
		"pages-staff-time-table-add-add-module"
	],
	"../pages/staff/time-table/list/list.module": [
		"./src/app/pages/staff/time-table/list/list.module.ts",
		"pages-staff-time-table-list-list-module"
	],
	"../pages/staff/time-table/upload/upload.module": [
		"./src/app/pages/staff/time-table/upload/upload.module.ts",
		"pages-staff-time-table-upload-upload-module"
	],
	"../pages/super-admin/academic-year/year.module": [
		"./src/app/pages/super-admin/academic-year/year.module.ts",
		"pages-super-admin-academic-year-year-module"
	],
	"../pages/super-admin/admin-mgmt/view/view.module": [
		"./src/app/pages/super-admin/admin-mgmt/view/view.module.ts",
		"pages-super-admin-admin-mgmt-view-view-module"
	],
	"../pages/super-admin/app-modules/view.module": [
		"./src/app/pages/super-admin/app-modules/view.module.ts",
		"pages-super-admin-app-modules-view-module"
	],
	"../pages/super-admin/app-version/list.module": [
		"./src/app/pages/super-admin/app-version/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-super-admin-app-version-list-module"
	],
	"../pages/super-admin/dashboard/dashboard.module": [
		"./src/app/pages/super-admin/dashboard/dashboard.module.ts",
		"pages-super-admin-dashboard-dashboard-module"
	],
	"../pages/super-admin/forgot-password/forgot-password.module": [
		"./src/app/pages/super-admin/forgot-password/forgot-password.module.ts",
		"pages-super-admin-forgot-password-forgot-password-module"
	],
	"../pages/super-admin/login/login.module": [
		"./src/app/pages/super-admin/login/login.module.ts",
		"pages-super-admin-login-login-module"
	],
	"../pages/super-admin/reset-password/reset-password.module": [
		"./src/app/pages/super-admin/reset-password/reset-password.module.ts",
		"pages-super-admin-reset-password-reset-password-module"
	],
	"../pages/super-admin/school-config/list.module": [
		"./src/app/pages/super-admin/school-config/list.module.ts",
		"default~pages-admin-academics-chapters-list-list-module~pages-admin-academics-chapters-upload-upload~948abac8",
		"common",
		"pages-super-admin-school-config-list-module"
	],
	"../pages/unauthorized/unauthorized.module": [
		"./src/app/pages/unauthorized/unauthorized.module.ts",
		"pages-unauthorized-unauthorized-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;